import Layout from "../../../../src/contents/pricing/Layout";
import SEO from "../../../../src/components/seo";
import React from 'react';
export default {
  Layout,
  SEO,
  React
};